<wiz-vgroup class="section-container" width="100%" height="100%">
  <wiz-hgroup width="100%" horizontalAlign="end">
    <wiz-label class="smallTitleLabel" width="100%" [wizLabel]="'$.process.engine.configure.$'"></wiz-label>
    <wiz-button class="hyperButton" [wizIcon]="'close'" (wizClick)="hide()"></wiz-button>
  </wiz-hgroup>
  
  <wiz-hgroup width="100%" height="100%">
      <wiz-vgroup #detailZone wizValidationContainer width="100%" height="100%" padding="5px">
      
        <wiz-text-input #tiCode width="100%" 
          [wizLabel]="'$.generator.query.field.$'"
          [wizMandatory]="true">
        </wiz-text-input>

        <wiz-text-area #taValue
          [wizLabel]="'$.generator.query.criteria.$'"
          width="100%"
          height="80px"
          [wizMandatory]="true"
          [wizMaxChars]="2000">
        </wiz-text-area>


      <wiz-spacer height="100%"></wiz-spacer>
      <wiz-hgroup width="100%" horizontalAlign="end" style="padding-top: 10px;">
        <wiz-button [wizLabel]="'$.common.validate.$'" (wizClick)="validate()" [wizDisabled]="!isValidable" width="200px"></wiz-button>
      </wiz-hgroup>

      </wiz-vgroup>

  </wiz-hgroup>



</wiz-vgroup>